// import {initCounter} from '../plugins/counter';

var inScene = null;
var scene1 = null;
var scene2 = null;
var scene3 = null;
var scene1b = null;
var scene2b = null;
var scene3b = null;
var animate_1 = true;
var animate_2 = true;
var animate_3 = true;
// var outScene = null;

$(function () {
    // var gap = $('.section-1-3 .scrollable-content').innerWidth() - $(window).width();
    fadeScrollInit();
    // }
    let resizedFinished;
    $(window).on('resize', function() {
        clearTimeout(resizedFinished);
        resizedFinished = setTimeout(function(){
            fadeScrollInit();
        }, 250);
    });
});

// horizontal scroll tween
function fadeScrollInit() {
    // var windowWidth = $(window).width();
    if(inScene !== null){
        // outScene.destroy(true);
        inScene.destroy(true);
        scene1.destroy(true);
        scene2.destroy(true);
        scene3.destroy(true);
        scene1b.destroy(true);
        scene2b.destroy(true);
        scene3b.destroy(true);
    }

    if ($(window).width() > 576) {
        var duration = .75;
        var triggerHook = .25;
    } else {
        var duration = .5;
        var triggerHook = .5;
    }

    // create scene to pin and link animation
    inScene = new ScrollMagic.Scene({
        offset        : 0,
        triggerElement: '.section-4-1 .pinned',
        triggerHook   : 0,
        duration      : $('.section-4-1 .scene-2').outerHeight() + $('.section-4-1 .scene-3').outerHeight()
    })
        .setPin('.section-4-1 .pinned')
        .addTo(require('../scrollInit'));

    // create animation per scene
    var scene1TL =  new TimelineMax()
                    .to(".section-4-1 .scene-1 .watermark", 1, { yPercent: 50 }, "start")
                    .to(".section-4-1 .scene-1 .content-topic4-program", duration, { alpha: 0 }, .25);
                    
    scene1 = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-1",
        triggerHook: .25,
        duration: $(".section-4-1 .scene-1").height()
    })
    .setTween(scene1TL)
    .on('start', function(event) {
        // running when scroll forward
        if(animate_1 === true) {
            $('.section-4-1 .scene-1 .realization-progress').css('width', '8%');
            // initCounter('.section-4-1 .scene-1 .realization h5 span', 1000);

            // animate_1 =  false;
        }
    })
    .on('leave', function(event) {
        if (animate_1 === true) {
            $('.section-4-1 .scene-1 .realization-progress').css('width', '0%');
        }
    })
    .addTo(require('../scrollInit'));      
    scene1b = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-1",
        triggerHook: 0,
        duration: $(".section-4-1 .scene-1").height()
    })
    .on('leave', function(event) {
        // console.log(event.scrollDirection);
        if(event.scrollDirection == 'REVERSE') {
            $('.section-4-1 .scene-1 .realization-progress').css('width', '8%');
        }
    })
    .addTo(require('../scrollInit'));  

    // scene 2
    var scene2TL =  new TimelineMax()
                    .to(".section-4-1 .scene-2 .watermark", 1, { yPercent: 50 }, "start")
                    .to(".section-4-1 .scene-2 .content-topic4-program", duration, { alpha: 0 }, .25);
                    
    scene2 = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-2",
        triggerHook: triggerHook,
        duration: $(".section-4-1 .scene-2").height()
    })
    .setTween(scene2TL)
    .on('start', function(event) {
        // running when scroll forward
        if(animate_2 === true) {
            $('.section-4-1 .scene-2 .realization-progress').css('width', '2%');
            // initCounter('.section-4-1 .scene-2 .realization h5 span', 1000);
            // animate_2 =  false;
        }
    })
    .on('leave', function(event) {
        if (animate_2 === true && event.scrollDirection == 'FORWARD') {
            $('.section-4-1 .scene-2 .realization-progress').css('width', '0%');
        }
    })
    .addTo(require('../scrollInit'));   

    scene2b = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-2",
        triggerHook: 0,
        duration: $(".section-4-1 .scene-2").height()
    })
    .on('leave', function(event) {
        // console.log(event.scrollDirection);
        if(event.scrollDirection == 'REVERSE') {
            $('.section-4-1 .scene-2 .realization-progress').css('width', '2%');
        }
    })
    .addTo(require('../scrollInit'));   

    // scene 3
    var scene3TL =  new TimelineMax()
                    .to(".section-4-1 .scene-3 .watermark", 1, { yPercent: 50 }, "start");
                    
    scene3 = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-3",
        triggerHook: triggerHook,
        duration: $(".section-4-1 .scene-3").height()
    })
    .setTween(scene3TL)
    .on('start', function(event) {
        // running when scroll forward
        if(animate_3 === true) {
            $('.section-4-1 .scene-3 .realization-progress').css('width', '2%');
            // initCounter('.section-4-1 .scene-3 .realization h5 span', 1000);

            // animate_3 =  false;
        }
    })
    .on('leave', function(event) {
        if (animate_3 === true) {
            $('.section-4-1 .scene-3 .realization-progress').css('width', '0%');
        }
    })
    .addTo(require('../scrollInit'));     
    
    scene3b = new ScrollMagic.Scene({
        triggerElement: ".section-4-1 .scene-3",
        triggerHook: 0,
        duration: $(".section-4-1 .scene-3").height()
    })
    .on('leave', function(event) {
        // console.log(event.scrollDirection);
        if(event.scrollDirection == 'REVERSE') {
            $('.section-4-1 .scene-3 .realization-progress').css('width', '2%');
        }
    })
    .addTo(require('../scrollInit'));  
}